// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + "viteWorker" + "." + "4c8f36adf" + ".chunk.js";
};